import {Client} from "../../autogenerate/api.generated.clients";

export const useDeleteCompressorOrgAssociation = function() {
    return {
        deleteCompressorOrganizationAssociation: (frameSerialNumber: string, organizationId: number) => new Client().organization_DeleteCompressorOrgAssociation(frameSerialNumber, organizationId)
    }
}